
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

interface ComparativaData {
  media_individual: number;
  media_equipo: number;
  media_organizacion: number;
  miembros_equipo: number;
  total_participantes_organizacion: number;
  diferencia_individual_equipo: number;
  diferencia_individual_organizacion: number;
  diferencia_equipo_organizacion: number;
  // Medias por rol y nivel (mantener si existen en backend)
  mentor_individual: number;
  mentor_equipo: number;
  mentor_organizacion: number;
  manager_individual: number;
  manager_equipo: number;
  manager_organizacion: number;
  messenger_individual: number;
  messenger_equipo: number;
  messenger_organizacion: number;
}

export function useComparativaData(submissionId: number) {
  return useQuery({
    queryKey: ['submission-comparativa', submissionId],
    queryFn: async (): Promise<ComparativaData | null> => {
      try {
        const { data, error } = await supabase.functions.invoke('render-report', {
          body: { 
            submissionId, 
            templateId: 1, // Usar cualquier template solo para obtener la comparativa
            validation_only: true 
          }
        });
        
        if (error) {
          console.warn('Error fetching comparison data:', error);
          return null;
        }
        
        // Extraer datos de comparativa de tres niveles de la respuesta
        if (data?.media_individual !== undefined) {
          return {
            media_individual: data.media_individual,
            media_equipo: data.media_equipo,
            media_organizacion: data.media_organizacion,
            miembros_equipo: data.miembros_equipo,
            total_participantes_organizacion: data.total_participantes_organizacion,
            diferencia_individual_equipo: data.diferencia_individual_equipo,
            diferencia_individual_organizacion: data.diferencia_individual_organizacion,
            diferencia_equipo_organizacion: data.diferencia_equipo_organizacion,
            // Medias por rol y nivel
            mentor_individual: data.answersMentor_avg ?? 0,
            mentor_equipo: data.answersMentor_avgEquipo ?? 0,
            mentor_organizacion: data.answersMentor_avgOrganizacion ?? 0,
            manager_individual: data.answersManager_avg ?? 0,
            manager_equipo: data.answersManager_avgEquipo ?? 0,
            manager_organizacion: data.answersManager_avgOrganizacion ?? 0,
            messenger_individual: data.answersMessenger_avg ?? 0,
            messenger_equipo: data.answersMessenger_avgEquipo ?? 0,
            messenger_organizacion: data.answersMessenger_avgOrganizacion ?? 0
          };
        }
        
        return null;
      } catch (error) {
        console.warn('Failed to fetch comparison data:', error);
        return null;
      }
    },
    enabled: !!submissionId,
    staleTime: 5 * 60 * 1000, // Cache por 5 minutos
    retry: false
  });
}
